import React from "react";
import { Form, Input, Select, Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import {
  listOfMeasurement,
  listOfMedication,
  medicineTypes,
} from "../common/helper/MedicineList";

const MedicineForm = ({ form }) => {
  const { t } = useTranslation();

  const requiredMessage = (fieldKey) => ({
    required: true,
    message: `${t("validation.pleaseEnter")} ${t(fieldKey).toLowerCase()}!`,
  });

  return (
    <React.Fragment>
      Medication Administrator
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="manufacturer"
              label={t("tableHeader.manufacturer")}
              rules={[requiredMessage("tableHeader.manufacturer")]}
            >
              <Input
                placeholder={t("validation.pleaseEnter", {
                  field: t("tableHeader.manufacturer"),
                })}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="medicine"
              label={t("tableHeader.medicineName")}
              rules={[requiredMessage("tableHeader.medicineName")]}
            >
              <Select
                placeholder={t("validation.pleaseEnter", {
                  field: t("tableHeader.medicineName"),
                })}
              >
                {Object.entries(listOfMedication).map(([key, value]) => (
                  <Select.Option key={key} value={key}>
                    {value}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="unit_of_measurement"
              label={t("tableHeader.unitOfMeasurement")}
              rules={[requiredMessage("tableHeader.unitOfMeasurement")]}
            >
              <Select
                placeholder={t("validation.pleaseEnter", {
                  field: t("tableHeader.unitOfMeasurement"),
                })}
              >
                {Object.entries(listOfMeasurement).map(([key, value]) => (
                  <Select.Option key={key} value={key}>
                    {value}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="medicine_type"
              label={t("tableHeader.type")}
              rules={[requiredMessage("tableHeader.type")]}
            >
              <Select
                placeholder={t("validation.pleaseEnter", {
                  field: t("tableHeader.type"),
                })}
              >
                {Object.entries(medicineTypes).map(([key, value]) => (
                  <Select.Option key={key} value={key}>
                    {value}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="status"
              label={t("tableHeader.status")}
              rules={[requiredMessage("tableHeader.status")]}
            >
              <Select
                placeholder={t("validation.pleaseEnter", {
                  field: t("tableHeader.status"),
                })}
              >
                <Select.Option value="active">{t("status.active")}</Select.Option>
                <Select.Option value="inactive">{t("status.inactive")}</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="dosage_route"
              label={t("medicine.dosageRoute")}
              rules={[requiredMessage("medicine.dosageRoute")]}
            >
              <Select
                placeholder={t("validation.pleaseEnter", {
                  field: t("medicine.dosageRoute"),
                })}
              >
                <Select.Option value="oral"> Oral</Select.Option>
                <Select.Option value="topical"> Topical</Select.Option>
                <Select.Option value="inhalation"> Inhalation</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="stock_quantity"
              label={t("tableHeader.inventory")}
              rules={[requiredMessage("tableHeader.inventory")]}
            >
              <Input
                type="number"
                placeholder={t("validation.pleaseEnter", {
                  field: t("tableHeader.inventory"),
                })}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="threshold"
              label="Threshold"
              rules={[requiredMessage("threshold")]}
            >
              <Input
                type="number"
                placeholder={t("validation.pleaseEnter", {
                  field: "Threshold",
                })}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </React.Fragment>
  );
};

export default MedicineForm;
